export const resolveConfig = async (source) => {
    if (!source)
        return {};
    if (typeof source === 'function') {
        return await source();
    }
    else {
        return source;
    }
};
export const replacePathParams = (pathTemplate, pathParams) => {
    if (!pathParams) {
        return pathTemplate;
    }
    let path = pathTemplate;
    for (const [k, v] of Object.entries(pathParams)) {
        path = path.replace(`:${k}`, String(v));
    }
    return path;
};
export const convertToFormData = (source) => {
    const formData = new FormData();
    for (const [k, v] of Object.entries(source)) {
        if (Array.isArray(v)) {
            for (const value of v) {
                formData.append(k, value);
            }
        }
        else {
            formData.append(k, v);
        }
    }
    return formData;
};
export const stringifyValues = (source) => source && Object.fromEntries(Object.entries(source).map(([k, v]) => [k, String(v)]));
